import "./styles.css";

export default function Section() {
  return (
    <div id="about" className="container-section">
      <div className="section">
        <div>
          <h2 className="about-me">Sobre Mim</h2>
        </div>
        <div className="text-about-me">
          <span className="about-me-p">
            Baiano natural de salvador, tenho 28 anos de idade, cursando análise
            e desenvolvimento de sistemas pela Unigranrio. Atualmente estou
            aperfeiçoando o meu conhecimento em Javascript, react e node.js,
            implementando API's e bancos de dados SQL Server em projetos
            pessoais e bootcamps. Durante toda minha trajetória de estudos e
            projetos pessoais tive a oportunidade de desenvolver habilidades
            como trabalho em equipe, gestão de tempo e conflitos e linguagem
            não-violenta.
          </span>
        </div>
      </div>
    </div>
  );
}
